<template>
  <div class="basic-info">
    <el-form :model="basicInfoForm"
             :rules="rules"
             ref="basicInfoRef"
             label-width="140px">
      <el-form-item label="医生义诊活动名称"
                    prop="free_name">
        <el-input v-model="basicInfoForm.free_name"
                  size="small"
                  clearable
                  placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="医生义诊活动说明"
                    prop="free_desc">
        <el-input v-model="basicInfoForm.free_desc"
                  size="small"
                  clearable
                  placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="图文详情"
                    prop="info_pic"
                    class="info-pic">
        <UploadImg :f_thumb="basicInfoForm.info_pic"
                   :f_thumb_str="basicInfoForm.info_pic_str"
                   @emitImg="emitImg"></UploadImg>
      </el-form-item>

      <el-form-item size="small">
        <el-button type="primary"
                   :disabled="module_id_array[0]?!module_id_array.includes('1187'):false"
                   @click="saveBtn('basicInfoRef')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import _ from 'lodash';
import department from '@/api/department.js';
import UploadImg from '@/components/uploadImg/index';
export default {
  components: {
    UploadImg
  },
  data() {
    return {
      basicInfoForm: {
        free_name: '',
        free_desc: '',
        info_pic: '',
        info_pic_str: ''
      },
      rules: {
        free_name: [
          { required: true, max: 10, message: '请输入', trigger: 'blur' }
        ],
        free_desc: [{ max: 50, message: '请输入', trigger: 'blur' }],
        info_pic: [{ required: true, message: '请上传', trigger: 'change' }]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      const loading = this.$loading();
      let { free_id } = this.routeQuery;
      department
        .freeDoctorGroupDetail({ free_id })
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.basicInfoForm = data;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    emitImg(data) {
      let { pic, path } = data;
      this.basicInfoForm.info_pic = pic;
      this.basicInfoForm.info_pic_str = path;
    },
    saveBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let params = _.pick(this.basicInfoForm, [
            'free_id',
            'free_name',
            'free_desc',
            'info_pic'
          ]);
          department
            .updateFreeDoctorGroup(params)
            .then((res) => {
              let { code, data } = res;
              if (code === 0) {
                this.$message.success('保存成功');
                this.getInfo();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.basic-info {
  width: 700px;
  .el-form {
    .info-pic {
      ::v-deep .el-form-item__content {
        height: 110px;
      }
    }
  }
}
</style>